import { Injectable } from '@angular/core';
import {
  HttpErrorResponse,
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { RuntimeConfigService } from '../config/runtime-config.service';
import { ConnectivityService } from './connectivity.service';

@Injectable({ providedIn: 'root' })
export class OfflineApiInterceptor implements HttpInterceptor {
  constructor(
    private connectivity: ConnectivityService,
    private runtime: RuntimeConfigService,
  ) {}

  intercept(req: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    if (this.connectivity.isOnline || !this.isApiCall(req.url)) {
      return next.handle(req);
    }
    return throwError(() => new HttpErrorResponse({
      status: 0,
      statusText: 'Offline',
      url: req.url,
      error: { offline: true },
    }));
  }

  private isApiCall(url: string): boolean {
    const base = this.runtime.apiBaseUrl;
    return !!base && (url.startsWith(base) || (base === '/api' && url.startsWith('/api/')));
  }
}
